import * as aTypes from "./actionTypes";

export const setFiltersActivities = (filters) => {
  return {
    type: aTypes.LIST_FILTERS_ACTIVTS_SET,
    filters: filters,
  };
};

export const resetFiltersActivities = (filters) => {
  return {
    type: aTypes.LIST_FILTERS_ACTIVTS_RESET,
    filters: filters,
  };
};

export const toggleFilterDifficulty = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_DIFFICULTY,
    key: key,
    forceUpdate: forceUpdate,
  };
};

export const toggleFilterType = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_TYPE,
    key: key,
    forceUpdate: forceUpdate,
  };
};

export const toggleFilterAbilityFono = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_ABILITY_FONO,
    key: key,
    forceUpdate: forceUpdate,
  };
};
export const toggleFilterAbilityPaid = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_ABILITY_PAID,
    key: key,
    forceUpdate: forceUpdate,
  };
};
export const toggleFilterAbilityFree = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_ABILITY_FREE,
    key: key,
    forceUpdate: forceUpdate,
  };
};

export const toggleFilterAgeRange = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_AGE_RANGE,
    key: key,
    forceUpdate: forceUpdate,
  };
};

export const setFilterByName = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_BY_NAME,
    key: key,
    forceUpdate: forceUpdate,
  };
};

export const setFilterOrderBy = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_ORDER_BY,
    key: key,
    forceUpdate: forceUpdate,
  };
};

export const toggleFilterLanguage = (key,forceUpdate = false) => {
  return {
    type: aTypes.ACTIVE_FILTER_LANGUAGE,
    key: key,
    forceUpdate: forceUpdate,
  };
};
